"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitColumns = exports.tenantColumns = exports.meterColumns = exports.billingPeriodColumns = void 0;
var billingPeriodColumns = [
    { name: "PERIOD", uid: "period" },
    { name: "START DATE", uid: "startDate" },
    { name: "END DATE", uid: "endDate" },
    { name: "DESCRIPTION", uid: "description" },
    { name: "STATUS", uid: "status" },
    { name: "ACTIONS", uid: "actions" },
];
exports.billingPeriodColumns = billingPeriodColumns;
var unitColumns = [
    { name: "UNIT NUMBER", uid: "areaNumber" },
    { name: "DESCRIPTION", uid: "description" },
    { name: "FLOOR", uid: "physicalAddress" },
    { name: "AREA (m\u00B2)", uid: "areaSize" },
    { name: "STATUS", uid: "status" },
    { name: "SOURCE", uid: "source" },
    { name: "CREATED", uid: "createdAt" },
];
exports.unitColumns = unitColumns;
var meterColumns = [
    { name: "METER ID", uid: "meterId" },
    { name: "TYPE", uid: "meterType" },
    { name: "SERIAL NUMBER", uid: "serialNumber" },
    { name: "LOCATION", uid: "meterLocation" },
    { name: "STATUS", uid: "status" },
    { name: "SOURCE", uid: "source" },
    { name: "PHASES", uid: "phaseCount" },
    { name: "RATE CARD", uid: "rateCard" },
];
exports.meterColumns = meterColumns;
var tenantColumns = [
    { name: "CLIENT NAME", uid: "tenantName" },
    { name: "SHOP NUMBER", uid: "unitName" },
    { name: "TYPE", uid: "occupancyType" },
    { name: "STATUS", uid: "status" },
    { name: "BUSINESS START DATE", uid: "startDate" },
    { name: "CONTACT", uid: "tenantContact" },
];
exports.tenantColumns = tenantColumns;
